import { NewPlanStages } from 'components/newPlan/constants';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import {
    SegmentEventButtonNames,
    SegmentEventActionNames,
    SegmentEventActionTypes,
    SegmentEventNameTypes,
} from 'utils/segment/constants';
import { useViewport } from 'utils/responsive';
import { IModelPlans } from '../types';
import PlanDetailsCard from './planDetailsCard';
import * as Styles from './styles';
import sendSegmentEvent from 'utils/segment';

interface IProps {
    plans: IModelPlans[];
}

function SelectPlan({ plans }: IProps) {
    const {
        planDetails,
        setPlanDetails,
        setActiveStage,
        permissions,
        userDetails,
    } = useContext(MPosContext);
    const { isMobile } = useViewport();

    const onSelect = (
        planId: string,
        planName: string,
        premium: number,
        planCategory: string,
        programId: string,
        emiEnabled: boolean,
        paymentMode: 'FULL' | 'EMI',
        productCode?: string
    ) => {
        if (permissions.purchase_journey === 'v0') {
            setActiveStage(NewPlanStages.IMEI);
        } else {
            setActiveStage(NewPlanStages.CUSTOMER_DEVICE_DETAILS);
        }
        setPlanDetails({
            ...planDetails,
            plan: {
                ...planDetails.plan,
                plan_id: planId,
                plan_name: planName,
                purchase_date: new Date().toISOString(),
                premium,
                plan_category: planCategory,
                program_id: programId,
                ...(productCode !== undefined && { product_code: productCode }),
                payment_mode: paymentMode,
                emi_enabled: emiEnabled,
                emi_selected: paymentMode === 'EMI',
            },
        });
        /**
         * Segment event
         */
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.SELECT_PLAN,
                button_name: SegmentEventButtonNames.SELECT_PLAN,
            },
            { userDetails, isMobile }
        );
    };

    return (
        <Styles.Wrapper>
            <Styles.SelectPlanText>Select your plan</Styles.SelectPlanText>
            {plans.map(
                ({
                    plan_id,
                    plan_name,
                    premium,
                    plan_category,
                    program_id,
                    benefits,
                    discounted_amount,
                    reason,
                    eligible,
                    product_code,
                    emi_enabled,
                }) => (
                    <PlanDetailsCard
                        key={plan_id}
                        planId={plan_id}
                        name={plan_name}
                        benefits={benefits}
                        premium={premium}
                        planCategory={plan_category}
                        programId={program_id}
                        onClick={onSelect}
                        discountedAmount={discounted_amount}
                        reason={reason}
                        eligible={eligible ?? true}
                        productCode={product_code}
                        emiEnabled={emi_enabled}
                    />
                )
            )}
        </Styles.Wrapper>
    );
}

export default SelectPlan;
